import { Table } from '@statsbomb/kitbag-components';
import { useSetAtom } from 'jotai';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { technicalMetadataWarningsAtom } from '../../atoms/approval';
import useApi, { API_ENDPOINTS } from '../../hooks/api';

export const DEFAULT_WARNING_CODES_WORTHY_OF_BLOCKING_APPROVAL =
  'aspect_ratio_not_supported,codec_not_supported,variable_frame_rate';

const WARNING_CODES_WORTHY_OF_BLOCKING_APPROVAL = (
  process.env.REACT_APP_WARNING_CODES_WORTHY_OF_BLOCKING_APPROVAL ||
  DEFAULT_WARNING_CODES_WORTHY_OF_BLOCKING_APPROVAL
).split(',');

export function TechnicalMetadataChecklist({
  sport,
  videoKey,
  onLoadedWithoutBlockingErrors,
  onLoading,
}) {
  const api = useApi();
  const setTechnicalMetadataWarnings = useSetAtom(
    technicalMetadataWarningsAtom,
  );

  const checkForWarningsWorthOfBlockingApproval = (warnings) => {
    const warningCodes = warnings.map((warning) => warning.code);
    return (
      warningCodes?.length > 0 &&
      WARNING_CODES_WORTHY_OF_BLOCKING_APPROVAL.some((code) =>
        warningCodes.includes(code),
      )
    );
  };

  const refreshData = async () => {
    onLoading();
    setTechnicalMetadataWarnings([]);
    const response = await api.get(
      `${API_ENDPOINTS.videoService}/videos/${sport}/${videoKey}/metadata`,
    );
    if (
      response?.data?.metadata &&
      !checkForWarningsWorthOfBlockingApproval(
        response.data.metadata?.warnings || [],
      )
    ) {
      onLoadedWithoutBlockingErrors();
    }
    setTechnicalMetadataWarnings(response?.data?.metadata?.warnings || []);
  };

  useEffect(() => {
    refreshData();
  }, []);

  const { frame_rate: frameRate, resolution } = {
    ...api.response?.data?.metadata,
  };
  return (
    <Table>
      <Table.Head>
        <Table.HeaderCell colSpan={2}>
          <FormattedMessage defaultMessage="Technical Data" id="6af73" />
        </Table.HeaderCell>
      </Table.Head>
      <Table.Body>
        {!api.isLoading && api.response?.data?.metadata ? (
          <>
            <Table.Row>
              <Table.DataCell $textAlign="left">
                <FormattedMessage defaultMessage="Resolution" id="b5a4b" />
              </Table.DataCell>
              <Table.DataCell $textAlign="left">
                {`${resolution.height} X ${resolution.width}`}
              </Table.DataCell>
            </Table.Row>
            <Table.Row>
              <Table.DataCell $textAlign="left">
                <FormattedMessage defaultMessage="Framerate" id="bcf96" />
              </Table.DataCell>
              <Table.DataCell $textAlign="left">
                {frameRate && Math.round(frameRate)}
              </Table.DataCell>
            </Table.Row>
          </>
        ) : (
          <Table.Row>
            <Table.DataCell $textAlign="left">
              {api.errorMessage ? (
                <FormattedMessage
                  defaultMessage="Technical metadata failed to load"
                  id="4f480"
                />
              ) : (
                <FormattedMessage defaultMessage="Loading" id="16bfb" />
              )}
            </Table.DataCell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
  );
}

TechnicalMetadataChecklist.propTypes = {
  onLoadedWithoutBlockingErrors: PropTypes.func,
  onLoading: PropTypes.func,
  sport: PropTypes.string.isRequired,
  videoKey: PropTypes.string.isRequired,
};
TechnicalMetadataChecklist.defaultProps = {
  onLoadedWithoutBlockingErrors: () => {},
  onLoading: () => {},
};

export default { TechnicalMetadataChecklist };
